/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootState } from "@/redux/store";

export const operatorsSelector = (state: RootState) => state.operator.operators;
export const activeOperatorSelector = (state: RootState) => state.operator.activeOperator;
export const operatorIdSelector = (state: any) => state.operator.activeOperator?.id;
export const defaultCountrySelector = (state: any) => state.operator.activeOperator?.country;
